import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'

import strings from '@constants/strings'
import { addRemarks } from '@data/conn/post/organisation'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Pill, Textarea } from '@baseV2'

import { InputsWrapper } from '../styles'

const PillWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
`

const OrgRemark = ({ orgDetails, update }) => {
	const dispatch = useDispatch()
	const user = useSelector((state) => state.getIn(['user', 'user']))
	const [remarks, setRemarks] = useState(orgDetails?.remarks ?? '')

	const addRemarksHandler = () => {
		dispatch(showLoader(true))
		addRemarks({ orgId: orgDetails.organisation_id, remarks, remarksBy: user.getUserDetails() })
			.then(() => {
				dispatch(showToast(true, strings('msg_remark_added'), { type: TOAST_TYPE.SUCCESS }))
				update()
				dispatch(toggleDrawer(false))
			})
			.catch((err) => {
				console.log(err)
				dispatch(showToast(true, strings('error_something_went_wrong'), { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => dispatch(showLoader(false)))
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputsWrapper>
					<Textarea id='org-remark-v2' label={strings('remarks')} value={remarks} onChange={(e) => setRemarks(e.target.value)} />
					{orgDetails.remarks && (
						<PillWrapper>
							<Pill>{`${strings('from')} - ${orgDetails?.remarks_by?.full_name || '--'}`}</Pill>
						</PillWrapper>
					)}
				</InputsWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button color='primary' onClick={addRemarksHandler} disabled={!remarks}>
					{orgDetails?.remarks ? strings('update', 'remark') : strings('add', 'remark')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default OrgRemark
